import React from "react";
import loadable from "@loadable/component";
import AppLayout from "@/layout";
import PageLayout from "@/layout/PageLayout";
import {
  HomeOutlined,
  FileSearchOutlined,
  PayCircleOutlined,
  ShoppingCartOutlined,
  TeamOutlined,
  ShopOutlined,
  GiftOutlined,
  NotificationOutlined,
  StarOutlined,
  SettingOutlined,
  CommentOutlined,
  LineChartOutlined,
  DesktopOutlined,
  CustomerServiceOutlined,
} from "@ant-design/icons";

const routes = [
  {
    path: "/",
    element: AppLayout,
    redirect: "/home",
    name: "首页",
    icon: null,
    auth: false,
    hidden: false,
    routes: [
      {
        path: "/home",
        element: loadable(() => import("@/views/Home")),
        redirect: "",
        name: "首页",
        icon: <HomeOutlined />,
        auth: true,
        hidden: false,
        routes: [],
      },
      {
        path: "/inquirySheet",
        element: PageLayout,
        redirect: "/inquirySheet/undelivered",
        name: "询价单管理",
        icon: <FileSearchOutlined />,
        auth: true,
        hidden: false,
        routes: [
          {
            path: "/inquirySheet/undelivered",
            element: loadable(() => import("@/views/InquirySheet/Undelivered")),
            redirect: "",
            name: "未派单",
            icon: null,
            auth: true,
            hidden: false,
            routes: [],
          },
          {
            path: "/inquirySheet/undelivered/content/:id",
            element: loadable(() =>
              import("@/views/InquirySheet/Undelivered/content"),
            ),
            redirect: "",
            name: "未派单详情",
            icon: null,
            auth: true,
            hidden: true,
            routes: [],
          },
          {
            path: "/inquirySheet/toBeQuoted",
            element: loadable(() => import("@/views/InquirySheet/ToBeQuoted")),
            redirect: "",
            name: "待报价",
            icon: null,
            auth: true,
            hidden: false,
            routes: [],
          },
          {
            path: "/inquirySheet/toBeQuoted/content/:id",
            element: loadable(() =>
              import("@/views/InquirySheet/ToBeQuoted/content"),
            ),
            redirect: "",
            name: "待报价详情",
            icon: null,
            auth: true,
            hidden: true,
            routes: [],
          },
          {
            path: "/inquirySheet/toBeAudit",
            element: loadable(() => import("@/views/InquirySheet/ToBeAudit")),
            redirect: "",
            name: "待审核",
            icon: null,
            auth: true,
            hidden: false,
            routes: [],
          },
          {
            path: "/inquirySheet/toBeAudit/content/:id",
            element: loadable(() =>
              import("@/views/InquirySheet/ToBeAudit/content"),
            ),
            redirect: "",
            name: "待审核详情",
            icon: null,
            auth: true,
            hidden: true,
            routes: [],
          },
          {
            path: "/inquirySheet/toBeReturned",
            element: loadable(() =>
              import("@/views/InquirySheet/ToBeReturned"),
            ),
            redirect: "",
            name: "待回盘",
            icon: null,
            auth: true,
            hidden: false,
            routes: [],
          },
          {
            path: "/inquirySheet/toBeReturned/content/:id",
            element: loadable(() =>
              import("@/views/InquirySheet/ToBeReturned/content"),
            ),
            redirect: "",
            name: "待回盘详情",
            icon: null,
            auth: true,
            hidden: true,
            routes: [],
          },
          {
            path: "/inquirySheet/toBeOrder",
            element: loadable(() => import("@/views/InquirySheet/ToBeOrder")),
            redirect: "",
            name: "待客下单",
            icon: null,
            auth: true,
            hidden: false,
            routes: [],
          },
          {
            path: "/inquirySheet/toBeOrder/content/:id",
            element: loadable(() =>
              import("@/views/InquirySheet/ToBeOrder/content"),
            ),
            redirect: "",
            name: "待客下单详情",
            icon: null,
            auth: true,
            hidden: true,
            routes: [],
          },
          {
            path: "/inquirySheet/ordered",
            element: loadable(() => import("@/views/InquirySheet/Ordered")),
            redirect: "",
            name: "客户已下单",
            icon: null,
            auth: true,
            hidden: false,
            routes: [],
          },
          {
            path: "/inquirySheet/ordered/content/:id",
            element: loadable(() =>
              import("@/views/InquirySheet/Ordered/content"),
            ),
            redirect: "",
            name: "客户已下单详情",
            icon: null,
            auth: true,
            hidden: true,
            routes: [],
          },
        ],
      },
      {
        path: "/orderform",
        element: PageLayout,
        redirect: "/orderform/list",
        name: "订单管理",
        icon: <ShoppingCartOutlined />,
        auth: true,
        hidden: false,
        routes: [
          {
            path: "/orderform/list",
            element: loadable(() => import("@/views/Order")),
            redirect: "",
            name: "订单列表",
            icon: null,
            auth: true,
            hidden: false,
            routes: [],
          },
          {
            path: "/orderform/list/content/:id",
            element: loadable(() => import("@/views/Order/Content")),
            redirect: "",
            name: "订单详情",
            icon: null,
            auth: true,
            hidden: true,
            routes: [],
          },
        ],
      },
      {
        path: "/payment",
        element: PageLayout,
        redirect: "/payment",
        name: "收款管理",
        icon: <PayCircleOutlined />,
        auth: true,
        hidden: false,
        routes: [
          {
            path: "/payment/list",
            element: loadable(() => import("@/views/Payment/List")),
            redirect: "",
            name: "收款统计",
            icon: null,
            auth: true,
            hidden: false,
            routes: [],
          },
        ],
      },
      {
        path: "/customer",
        element: PageLayout,
        redirect: "/customer/list",
        name: "客户管理",
        icon: <TeamOutlined />,
        auth: true,
        hidden: false,
        routes: [
          {
            path: "/customer/list",
            element: loadable(() => import("@/views/Customer/List")),
            redirect: "",
            name: "客户统计",
            icon: null,
            auth: true,
            hidden: false,
            routes: [],
          },
        ],
      },
      {
        path: "/goods",
        element: PageLayout,
        redirect: "/goods",
        name: "商品管理",
        icon: <GiftOutlined />,
        auth: true,
        hidden: false,
        routes: [
          {
            path: "/goods/list",
            element: loadable(() => import("@/views/Goods/List")),
            redirect: "",
            name: "商品列表",
            icon: null,
            auth: true,
            hidden: false,
            routes: [],
          },
          {
            path: "/goods/content/:id",
            element: PageLayout,
            redirect: "",
            name: "商品详情",
            icon: null,
            auth: true,
            hidden: true,
            routes: [],
          },
        ],
      },
      {
        path: "/factory",
        element: PageLayout,
        redirect: "/factory",
        name: "工厂管理",
        icon: <ShopOutlined />,
        auth: true,
        hidden: false,
        routes: [
          {
            path: "/factory/user",
            element: loadable(() => import("@/views/Factory/FactoryUser")),
            redirect: "",
            name: "账号管理",
            icon: null,
            auth: true,
            hidden: false,
            routes: [],
          },
          {
            path: "/factory/goods",
            element: loadable(() => import("@/views/Factory/Goods")),
            redirect: "",
            name: "商品管理",
            icon: null,
            auth: true,
            hidden: false,
            routes: [],
          },
          {
            path: "/factory/order",
            element: loadable(() => import("@/views/Factory/Order")),
            redirect: "",
            name: "成交订单",
            icon: null,
            auth: true,
            hidden: false,
            routes: [],
          },
        ],
      },
      {
        path: "/activity",
        element: PageLayout,
        redirect: "/activity",
        name: "活动管理",
        icon: <NotificationOutlined />,
        auth: true,
        hidden: false,
        routes: [
          {
            path: "/activity/sell",
            element: loadable(() => import("@/views/Activity/Sell")),
            redirect: "",
            name: "首页推荐",
            icon: null,
            auth: true,
            hidden: false,
            routes: [],
          },
          {
            path: "/activity/discount",
            element: loadable(() => import("@/views/Activity/Discount")),
            redirect: "",
            name: "折扣商品",
            icon: null,
            auth: true,
            hidden: false,
            routes: [],
          },
          {
            path: "/activity/hot",
            element: loadable(() => import("@/views/Activity/Hot")),
            redirect: "",
            name: "热门搜索",
            icon: null,
            auth: true,
            hidden: false,
            routes: [],
          },
        ],
      },
      {
        path: "/promotion",
        element: PageLayout,
        redirect: "/promotion",
        name: "推广管理",
        icon: <StarOutlined />,
        auth: true,
        hidden: false,
        routes: [
          {
            path: "/promotion/partner",
            element: loadable(() => import("@/views/Promotion/Partner")),
            redirect: "",
            name: "合作商管理",
            icon: null,
            auth: true,
            hidden: false,
            routes: [],
          },
          {
            path: "/promotion/list",
            element: loadable(() => import("@/views/Promotion/List")),
            redirect: "",
            name: "推广明细",
            icon: null,
            auth: true,
            hidden: false,
            routes: [],
          },
          {
            path: "/promotion/order",
            element: loadable(() => import("@/views/Promotion/Order")),
            redirect: "",
            name: "推广订单",
            icon: null,
            auth: true,
            hidden: false,
            routes: [],
          },
        ],
      },
      {
        path: "/settings",
        element: PageLayout,
        redirect: "/settings/powerOn",
        name: "通用设置",
        icon: <SettingOutlined />,
        auth: true,
        hidden: false,
        routes: [
          {
            path: "/settings/powerOn",
            element: loadable(() => import("@/views/Settings/PowerOn")),
            redirect: "",
            name: "开机设置",
            icon: null,
            auth: true,
            hidden: false,
            routes: [],
          },
          {
            path: "/settings/banner",
            element: loadable(() => import("@/views/Settings/Banner")),
            redirect: "",
            name: "轮播图设置",
            icon: null,
            auth: true,
            hidden: false,
            routes: [],
          },
          {
            path: "/settings/hsCode",
            element: loadable(() => import("@/views/Settings/HSCode")),
            redirect: "",
            name: "HS Code设置",
            icon: null,
            auth: true,
            hidden: false,
            routes: [],
          },
          {
            path: "/settings/finance",
            element: loadable(() => import("@/views/Settings/Finance")),
            redirect: "",
            name: "财务设置",
            icon: null,
            auth: true,
            hidden: false,
            routes: [],
          },
          {
            path: "/settings/admin",
            element: loadable(() => import("@/views/Settings/Admin")),
            redirect: "",
            name: "管理员设置",
            icon: null,
            auth: true,
            hidden: false,
            routes: [],
          },
          {
            path: "/settings/logistics",
            element: loadable(() => import("@/views/Settings/Logistics")),
            redirect: "",
            name: "物流设置",
            icon: null,
            auth: true,
            hidden: false,
            routes: [],
          },
          {
            path: "/settings/prompt",
            element: loadable(() => import("@/views/Settings/Prompt")),
            redirect: "",
            name: "提示语设置",
            icon: null,
            auth: true,
            hidden: false,
            routes: [],
          },
          {
            path: "/settings/contract",
            element: loadable(() => import("@/views/Settings/Contract")),
            redirect: "",
            name: "合同设置",
            icon: null,
            auth: true,
            hidden: false,
            routes: [],
          },
          {
            path: "/settings/color",
            element: loadable(() => import("@/views/Settings/Color")),
            redirect: "",
            name: "颜色设置",
            icon: null,
            auth: true,
            hidden: false,
            routes: [],
          },
          {
            path: "/settings/other",
            element: loadable(() => import("@/views/Settings/Other")),
            redirect: "",
            name: "其他设置",
            icon: null,
            auth: true,
            hidden: false,
            routes: [],
          },
        ],
      },
      {
        path: "/comment",
        element: PageLayout,
        redirect: "/comment",
        name: "评论管理",
        icon: <CommentOutlined />,
        auth: true,
        hidden: false,
        routes: [
          {
            path: "/comment/user",
            element: loadable(() => import("@/views/Comment/User")),
            redirect: "",
            name: "用户设置",
            icon: null,
            auth: true,
            hidden: false,
            routes: [],
          },
          {
            path: "/comment/list",
            element: loadable(() => import("@/views/Comment/List")),
            redirect: "",
            name: "评论列表",
            icon: null,
            auth: true,
            hidden: false,
            routes: [],
          },
        ],
      },
      {
        path: "/customeService",
        element: PageLayout,
        redirect: "/customeService/list",
        name: "客服管理",
        icon: <CustomerServiceOutlined />,
        auth: true,
        hidden: false,
        badge: {
          show: true,
          offset: [30, 0],
        },
        routes: [
          {
            path: "/customeService/list",
            element: loadable(() => import("@/views/CustomerServcie/List")),
            redirect: "",
            name: "客服列表",
            icon: null,
            auth: true,
            hidden: false,
            routes: [],
          },
          {
            path: "/customeService/list/content/:id",
            element: loadable(() =>
              import("@/views/CustomerServcie/List/Content"),
            ),
            redirect: "",
            name: "客服详情",
            icon: null,
            auth: true,
            hidden: true,
            routes: [],
          },
          {
            path: "/customeService/keywords",
            element: loadable(() => import("@/views/CustomerServcie/Keywords")),
            redirect: "",
            name: "关键词管理",
            icon: null,
            auth: true,
            hidden: false,
            routes: [],
          },
        ],
      },
      {
        path: "/dataStatistics",
        element: PageLayout,
        redirect: "/dataStatistics/use",
        name: "数据统计",
        icon: <LineChartOutlined />,
        auth: true,
        hidden: false,
        routes: [
          {
            path: "/dataStatistics/user",
            element: loadable(() => import("@/views/DataStatistics/User")),
            redirect: "",
            name: "用户统计",
            icon: null,
            auth: true,
            hidden: false,
            routes: [],
          },
          {
            path: "/dataStatistics/inquirySheet",
            element: loadable(() =>
              import("@/views/DataStatistics/InquirySheet"),
            ),
            redirect: "",
            name: "询价单统计",
            icon: null,
            auth: true,
            hidden: false,
            routes: [],
          },
          {
            path: "/dataStatistics/orderStatus",
            element: loadable(() =>
              import("@/views/DataStatistics/OrderStatus"),
            ),
            redirect: "",
            name: "订单状态统计",
            icon: null,
            auth: true,
            hidden: false,
            routes: [],
          },
          {
            path: "/dataStatistics/paycollection",
            element: loadable(() => import("@/views/DataStatistics/Payment")),
            redirect: "",
            name: "收款统计",
            icon: null,
            auth: true,
            hidden: false,
            routes: [],
          },
          {
            path: "/dataStatistics/commission",
            element: loadable(() => import("@/views/DataStatistics/Commission")),
            redirect: "",
            name: "采购员提成",
            icon: null,
            auth: true,
            hidden: false,
            routes: [],
          },
          {
            path: "/dataStatistics/returned",
            element: loadable(() => import("@/views/DataStatistics/Returned")),
            redirect: "",
            name: "回盘统计",
            icon: null,
            auth: true,
            hidden: true,
            routes: [],
          },
          {
            path: "/dataStatistics/order",
            element: loadable(() => import("@/views/DataStatistics/Order")),
            redirect: "",
            name: "订单數量统计",
            icon: null,
            auth: true,
            hidden: false,
            routes: [],
          },
          {
            path: "/dataStatistics/amount",
            element: loadable(() => import("@/views/DataStatistics/Amount")),
            redirect: "",
            name: "订单金额统计",
            icon: null,
            auth: true,
            hidden: false,
            routes: [],
          },
          {
            path: "/dataStatistics/profit",
            element: loadable(() => import("@/views/DataStatistics/Profit")),
            redirect: "",
            name: "利润统计",
            icon: null,
            auth: true,
            hidden: false,
            routes: [],
          },
        ],
      },
      {
        path: "/system",
        element: PageLayout,
        redirect: "/system",
        name: "系统设置",
        icon: <DesktopOutlined />,
        auth: true,
        hidden: false,
        routes: [
          {
            path: "/system/role",
            element: loadable(() => import("@/views/System/Role")),
            redirect: "",
            name: "角色设置",
            icon: null,
            auth: true,
            hidden: false,
            routes: [],
          },
          {
            path: "/system/user",
            element: loadable(() => import("@/views/System/User")),
            redirect: "",
            name: "用户设置",
            icon: null,
            auth: true,
            hidden: false,
            routes: [],
          },
          {
            path: "/system/releaser",
            element: loadable(() => import("@/views/Releaser")),
            redirect: "",
            name: "版本管理",
            icon: null,
            auth: true,
            hidden: false,
            routes: [],
          },
        ],
      },
    ],
  },
  {
    path: "/login",
    element: loadable(() => import("@/views/Login/Login")),
    name: "登录",
    icon: null,
    auth: false,
    hidden: false,
    routes: [],
  },
  {
    path: "/agreement",
    element: loadable(() => import("@/views/Agreement")),
    name: "Agreement",
    icon: null,
    auth: false,
    hidden: false,
    routes: [],
  },
  {
    path: "/privacyPolicy",
    element: loadable(() => import("@/views/PrivacyPolicy")),
    name: "PrivacyPolicy",
    icon: null,
    auth: false,
    hidden: false,
    routes: [],
  },
  {
    path: "/powerOn",
    element: loadable(() => import("@/views/PowerOn")),
    name: "BUYBUYGO",
    icon: null,
    auth: false,
    hidden: false,
    routes: [],
  },
  {
    path: "/error",
    element: loadable(() => import("@/components/500")),
    name: "500 服务器发生错误",
    hidden: false,
    routes: [],
  },
  {
    path: "/forbidden",
    element: loadable(() => import("@/components/403")),
    name: "403 禁止访问",
    hidden: false,
    routes: [],
  },
  {
    path: "*",
    element: loadable(() => import("@/components/404")),
    name: "404 页面未找到",
    hidden: false,
    routes: [],
  },
];

export default routes;
